import Vue from 'vue';
import Oruga from '@oruga-ui/oruga';

export const OrugaConfig = {
	iconPack: 'fas',
	statusIcon: false,
	button: {
		// override: true,
		// rootClas: 'btn'
	},
	input: {
		// override: true,
		// rootClass: 'form-group',
		// inputClass: 'form-control'
	},
	field: {
		variantClass: 'text-',

	},
	autocomplete: {
		menuClass: 'dropdown-menu',
		itemClass: 'dropdown-item',
		itemHoverClass: 'active'
	},
	checkbox: {
		override: true
	}
}

if (typeof window.Vue === 'undefined') {
	Vue.use(Oruga, OrugaConfig);
}